import authenticated from "../middleware/authenticated";

import Main from "./modules/main";
import Auth from "./modules/auth";
import Profile from "./modules/profile";
import Insights from "./modules/insights";
import Analysis from "./modules/analysis";
import Guide from "./modules/guide";
import Requirement from "./modules/requirement";
import Tracker from "./modules/tracker";
import Updates from "./modules/updates";
import Global from "./modules/global";
import Search from "./modules/search";
import Pages from "./modules/pages";
import Dialog from "./modules/dialog";
import Trackers from "./modules/trackers";
import Bookmarks from "./modules/bookmarks";
import ReportBuilder from "./modules/reportBuilder";
import CountryHub from "./modules/jurisdiction";
import InFocusHub from "./modules/inFocus";
import PageView from "./modules/pageView";
import Workspace from "./modules/workspace";
import Verticals from "./modules/verticals";
import FeedFilters from "./modules/feedFilters";
import Viq from "./modules/viq";

export const strict = true;

export const modules = {
  Main,
  Auth,
  Profile,
  Insights,
  Analysis,
  Guide,
  Requirement,
  Tracker,
  Updates,
  Global,
  Search,
  Pages,
  Dialog,
  Trackers,
  Bookmarks,
  ReportBuilder,
  CountryHub,
  InFocusHub,
  PageView,
  Workspace,
  Verticals,
  FeedFilters,
  Viq,
};

export const actions = {
  async nuxtServerInit(
    { $axios, state, dispatch, commit, params },
    { req, app, store, redirect, route }
  ) {
    await authenticated({ app, store, redirect, route });
  },
};
